import { blue } from "@ant-design/colors"
import { Checkbox, Space } from "antd"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren & {
  checked: boolean
  disabled?: boolean
  onClick?: () => void
}

const CheckboxButton = ({checked, disabled, onClick, children}: Props) => {
  const style = disabled
    ? disabledStyle
    : checked
      ? checkedStyle
      : uncheckedStyle

  return <div style={style} onClick={() => {
      if (!disabled) {
        onClick?.()
      }
    }}>
    <Space>
      <Checkbox checked={checked} disabled={disabled} />
      {children}
    </Space>
  </div>
}

export default CheckboxButton

const uncheckedStyle = {
  borderColor: '#00000026',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '12px',
  padding: '12px',
  cursor: 'pointer',
  backgroundColor: 'transparent'
}

const checkedStyle = {
  ...uncheckedStyle,
  borderColor: blue.primary,
  backgroundColor: blue[0]
}

const disabledStyle = {
  ...uncheckedStyle,
  borderColor: '#0000000F',
  backgroundColor: '#0000000A',
  cursor: 'not-allowed',
  color: '#999'
}
